import { StyleSheet, css } from 'aphrodite'
import React from 'react'

interface InfoGridProps {
  icon: string
  title: string
  description: string
}

export default function InfoGrid({ icon, title, description }: InfoGridProps) {
  return (
    <div className={css(styles.gridItem)}>
      <div className={css(styles.iconContainer)}>
        <img src={icon} alt={`${title} icon`} />
      </div>
      <div className={css(styles.textContainer)}>
        <h4 className={css(styles.title)}>{title}</h4>
        <p className={css(styles.description)}>{description}</p>
      </div>
    </div>
  )
}

const styles = StyleSheet.create({
  gridItem: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '16px',
    textAlign: 'left',
    '@media (min-width: 768px)': {
      gap: '20px',
    },
    '@media (min-width: 1024px)': {
      gap: '24px',
    },
  },
  iconContainer: {
    width: '48px',
    height: '48px',
    borderRadius: '50%',
    backgroundColor: '#D3EDFF',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    '@media (min-width: 768px)': {
      width: '56px',
      height: '56px',
    },
    '@media (min-width: 1024px)': {
      width: '64px',
      height: '64px',
    },
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
    '@media (min-width: 768px)': {
      gap: '7px',
    },
    '@media (min-width: 1024px)': {
      gap: '8px',
    },
  },
  title: {
    color: '#102E65',
    fontSize: '16px',
    fontWeight: 600,
    '@media (min-width: 768px)': {
      fontSize: '18px',
    },
    '@media (min-width: 1024px)': {
      fontSize: '20px',
    },
  },
  description: {
    color: '#4B5563',
    fontSize: '14px',
    lineHeight: 1.5,
    fontWeight: 400,
    '@media (min-width: 768px)': {
      fontSize: '15px',
    },
    '@media (min-width: 1024px)': {
      fontSize: '16px',
    },
  },
})
